// extracted by mini-css-extract-plugin
export default {"centerContainer":"AvailableLesson_centerContainer__EYdgl","header":"AvailableLesson_header__XGNQS"};